import { Slider, Stack, Group, Text } from '@mantine/core';

export default function MarkupSlider({ value, onChange, disabled }: { value: number; onChange: (v: number) => void; disabled?: boolean }) {
  return (
    <Stack gap={4}>
      <Group justify="space-between">
        <Text size="sm" fw={500}>Typical Markup</Text>
        <Text size="sm" c="orange" fw={600}>{value}%</Text>
      </Group>
      <Slider
        min={0} max={200} step={1}
        value={value} onChange={onChange}
        marks={[
          { value: 0, label: '0%' },
          { value: 30, label: '30%' },
          { value: 100, label: '100%' },
          { value: 200, label: '200%' },
        ]}
        disabled={disabled}
        color="orange"
      />
    </Stack>
  );
}
